export default function getResource(label, vars = []) {
    const resources = { startAReturn: 'Commencer un retour' };

    return resources[label];
}
